<template>
    <vueper-slides class="home-slide no-shadow" autoplay fixed-height :arrows="false" :touchable="false" >
      <vueper-slide key="2">
        <template v-slot:content>
          <home-slide-three />
        </template>
      </vueper-slide>
      <vueper-slide key="1">
        <template v-slot:content>
          <home-slide-one />
        </template>
      </vueper-slide>
    </vueper-slides>
</template>

<script>
import { VueperSlides, VueperSlide } from 'vueperslides'
import 'vueperslides/dist/vueperslides.css'

import HomeSlideOne from './home-slide-one'
import HomeSlideThree from './home-slide-three'

export default {
  data() {
    return {
    }
  },
  components: {
    VueperSlides, VueperSlide,
    HomeSlideOne,HomeSlideThree
  }
}
</script>

<style lang="less">
.home-slide {
  width: 100%;
  height: 450px;

  .vueperslides__bullet {
    margin: 30px 10px;
  }

  .vueperslides__bullet .default {
    border: none;
    box-shadow: none;
    transition: 0.3s;
    width:14px;
    height:14px;
    background-color:rgba(9,9,59,0.1);
  }

  .vueperslides__bullet--active .default {
    background-color: rgba(9,9,59,0.5);
  }
}
</style>


// WEBPACK FOOTER //
// src/components/home-slide.vue